import { __rest } from '../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '../Components/ui/collapsible.js';
import { cn } from '../lib/utils.js';
import { SearchIcon, ChevronDownIcon } from 'lucide-react';

const TaskItem = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React__default.createElement("div", Object.assign({ className: cn('tw:text-muted-foreground tw:text-sm', className) }, props), children));
};
const Task = (_a) => {
    var { defaultOpen = true, className } = _a, props = __rest(_a, ["defaultOpen", "className"]);
    return (React__default.createElement(Collapsible, Object.assign({ className: cn(className), defaultOpen: defaultOpen }, props)));
};
const TaskTrigger = (_a) => {
    var { children, className, title } = _a, props = __rest(_a, ["children", "className", "title"]);
    return (React__default.createElement(CollapsibleTrigger, Object.assign({ asChild: true, className: cn('tw:group', className) }, props), children !== null && children !== void 0 ? children : (React__default.createElement("div", { className: "tw:flex tw:w-full tw:cursor-pointer tw:items-center tw:gap-2 tw:text-muted-foreground tw:text-sm tw:transition-colors tw:hover:text-foreground" },
        React__default.createElement(SearchIcon, { className: "tw:size-4" }),
        React__default.createElement("p", { className: "tw:text-sm" }, title),
        React__default.createElement(ChevronDownIcon, { className: "tw:size-4 tw:transition-transform tw:group-data-[state=open]:rotate-180" })))));
};
const TaskContent = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React__default.createElement(CollapsibleContent, Object.assign({ className: cn('tw:data-[state=closed]:fade-out-0 tw:data-[state=closed]:slide-out-to-top-2 tw:data-[state=open]:slide-in-from-top-2 tw:text-popover-foreground tw:outline-none tw:data-[state=closed]:animate-out tw:data-[state=open]:animate-in', className) }, props),
        React__default.createElement("div", { className: "tw:mt-4 tw:pt-2 tw:flex tw:flex-col tw:gap-4 tw:space-y-2 tw:border-muted tw:border-l-2 tw:pl-4" }, children)));
};

export { Task, TaskContent, TaskItem, TaskTrigger };
//# sourceMappingURL=task.js.map
